import { get, post } from "../GenericServices";

const Rap = {
  getRapDetail: (id) => {
    return get(`project-estimate/${id}/rap`);
  },
  saveRap: (id, data) => {
    return post(`project-estimate/${id}/rap`, data);
  },
  emailRap: (id, data) => {
    return post(`project-estimate/${id}/rap/send-email`, data);
  },
};

export default Rap;
